export default "__VITE_ASSET__B_icjM0R__"